import { useContext } from 'react'
import { AuthContext } from './auth-context'

export {
  USER_TYPE_ADMIN,
  USER_TYPE_STANDARD,
  USER_TYPE_LIMITED,
  type UserType,
} from './auth-context'

export const useAuth = () => {
  return useContext(AuthContext)
}
